<template>
  <el-dialog
    :modal-append-to-body="false"
    ref="dialogRef"
    title="文件预览"
    top="8vh"
    :before-close="handleClose"
    :visible.sync="visible"
    :destroy-on-close="true"
  >
    <div class="flexLr" style="align-items: start;width:100%;height: 70vh;">
      <iframe
        width="100%"
        height="100%"
        allow="fullscreen"
        id="iframeId"
        frameborder="0"
        style="background-color: #fff;border-radius: 2px;"
        scrolling="auto"
        :src="url + '#scrollbars=0&toolbar=0&statusbar=0&view=FitH,top'"
        v-if="url"
      ></iframe>
    </div>
  </el-dialog>
</template>
<script>
import { OfficeOnline } from "@/setAxios.js";
export default {
  name: "",
  props: {},
  data() {
    return {
      ShowQuestion: false,
      url: null,
      fage: false,
      visible: false,
    };
  },
  methods: {
    async LookItemPics(filePaths) {
      this.visible = true;
      if (filePaths) {
        var suffix = filePaths.substring(filePaths.lastIndexOf(".") + 1);
        console.log(suffix);

        if (
          suffix == "pdf" ||
          suffix == "png" ||
          suffix == "jpg" ||
          suffix == "gif" ||
          suffix == "txt"
        ) {
          this.url = this.$store.state.baseUrl + filePaths;
          this.fage = true;
        } else {
          let params = {
            sourcePath: filePaths,
            type: "html",
          };
          let fd = new FormData();
          for (var key in params) {
            fd.append(key, params[key]);
          }
          let res = await OfficeOnline(fd);
          if (res.Code == 0) {
            this.$message.error(res.Message);
          } else {
            this.url = this.$store.state.baseUrl + res.Data; //你的地址
          }
        }
      }
    },
    openDialogMethod(filePaths) {
      this.visible = true;
    },
    handleClose(done) {
      this.visible = false;
      this.url = "";
      done();
    },
  },
  mounted() {},
  created() {},
};
</script>
<style lang="less" scoped></style>
